export const SET_ACCOUNTS = 'SET_ACCOUNTS'
export const SET_ASSETS = 'SET_ASSETS'
export const SET_EXPENSES = 'SET_EXPENSES'
export const SET_NETWORTH = 'SET_NETWORTH'
export const SET_YEARS = 'SET_YEARS'
export const SET_CO_BRAND_TOKEN = 'SET_CO_BRAND_TOKEN'
export const SET_USER_SESSION_TOKEN = 'SET_USER_SESSION_TOKEN'



// WEBPACK FOOTER //
// ./api/yodlee/actionTypes.js